<template>
    <div class="change-language text-center" :class="[device == 'mobile' ? 'change-language-mobile1' :'']">
        <v-menu class="menu" :rounded="rounded" offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn :color="color" :class="[isParty ? 'isParty' : '']" v-bind="attrs" v-on="on">
                    <img v-if="!isParty && !isHr" src="../assets/img/lang@2x.png" class="lang" />
                    <img v-else src="../assets/img/whitelang@2x.png" class="lang" />
                    <span class="lang-text" :class="[isParty ? 'isParty' : '']">{{ $t('Language') }}</span>
                </v-btn>
            </template>
            <v-list>
                <v-list-item @click="handle(item.key)" v-for="(item, index) in list" :key="index">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
    name: 'change-language',
    watch: {
        '$route': {
            handler: function () {
             
                this.autoRouteDisabled()
            }
        }
    },
    mounted() {
        this.autoRouteDisabled()
    },
    data() {
        return {
            isParty: false,
            isHr: false,
            color: 'white',
            rounded: true,
            list: [
                { key: 'en', name: 'English' }, // 英语
                { key: 'zh-CN', name: '中文' }, // 中文
            ],
        }
    },
    computed: {
        ...mapState({
        device: state => state.app.device
        }),
    },
    methods: {
        autoRouteDisabled() {
            if (new String(this.$route.path).indexOf('/party/building') > -1) {
                this.color = '#B51408'
                this.isParty = true
            } else if (new String(this.$route.path).indexOf('/about/list') > -1) {
                this.color = 'transparent'
            } else {
                this.color = '#ffffff'
            }
        },
        async handle(value) {
            localStorage.setItem('change-language', value)
            await this.getMenu()
            this.$i18n.locale = value
            let href = '/'
            if(this.$route.path == '/news/list/detail'){
                href = '/news/list'
            }else if(this.$route.name == 'informationListDetail'){
                href = '/information/list'
            }else if(this.$route.path.indexOf('/party/building') > -1){
                href = '/'
            }else if(this.$route.path.indexOf('/information/list') > -1){
                href = '/information/list'
            }else if(this.$route.path.indexOf('/about/list') > -1){
                href = '/about/list'
            }else if(this.$route.path == '/expertise/list/detail'){
                href = '/expertise/list'
            }else if(this.$route.path == '/service/list'){
                href = '/service/list'
            }else if (this.$route.path == '/dynamics/detail'){
                 href = '/dynamics'
            }else{
                href = this.$route.fullPath
            }
            let test = false,url = ''
            if(value == 'en'){
                if(test){
                    url = 'http://127.0.0.1:8081'
                }else{
                    url = 'https://c-nast.com'
                }
                href = url + href
            }else{
                // https://www.nast.com.cn
                // http://192.168.10.9:8080
                if(test){
                    url = 'http://192.168.111.153:8081'
                }else{
                    url = 'https://www.nast.com.cn'
                }
                href = url + href
            }   
            this.$nextTick(() => {
                location.href = href            
            })


        },
    },
}
</script>
<style lang="scss">
.change-language {
    .v-btn {
        box-shadow: unset !important;
    }

    .lang {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }

    .lang-text {
        font-weight: 300;
        font-size: 16px;
        color: #333333;
    }

    .langico {
        width: 24px;
        height: 19px;
        margin-right: 8px;
    }

    .menu {
        cursor: pointer !important;
    }

    .isParty {
        color: white;
    }
}
.change-language-mobile{
    .lang {
        width: 0.35rem;
        height: 0.35rem;
        margin-right: 0.1rem;
    }
    .lang-text{
        font-size: 0.34rem;
    }
}
</style>